import type {Keys} from 'react-hotkeys-hook';
import {UAParser} from 'ua-parser-js';

export const getOSControlKey = (): Keys => {
  const MAC_OS = `Mac OS` as const;
  const parser = new UAParser();
  const os = parser.getOS().name;

  return os === MAC_OS ? `meta` : `ctrl`;
};
